import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { BaseEditComponent } from '@app/cp/shared/base-components/base-edit.component';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { v_InvoiceLineItemBus } from '../../shared/models/v_InvoiceLineItemBus';
import { InvoiceService } from '../../shared/services/invoice.service';
import { CommonFunctions } from '../../shared/static/common-functions';
import { InvoiceLinesSaveParam } from '../../shared/models/InvoiceLinesSaveParam';
import { InvoiceLinesBus } from '../../shared/models/InvoiceLinesBus';
import { InvoiceMessageInfo } from '../../shared/models/InvoiceMessageInfo';
import { GItem } from '../../shared/models/GItem';
import { CreditMemoCORRLineItemsComponent } from './lineitems/credit-memo-corr-lineitems.component';
import { InvoiceBus } from '../../shared/models/InvoiceBus';
import { CommonParam } from '../../shared/models/CommonParam';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'credit-memo-corr',
    templateUrl: './credit-memo-corr.component.html',
    styleUrls: ['./credit-memo-corr.component.scss'],
    standalone: false
})
export class CreditMemoCORRComponent extends BaseEditComponent<v_InvoiceLineItemBus, InvoiceService, null, null> {
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService,  qry_rd: DQOIReferenceDataQuery, svc_data: InvoiceService) {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.readOnly = false;
        this.saveMode = SaveMode.all;
        this.appCode = "CreditMemoAndCorr"
    }
    @ViewChild('CreditMemoCORRLineItems') protected lineItems: CreditMemoCORRLineItemsComponent;
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();
    //@Output() titleChild = new EventEmitter<string>();
    editing: boolean = false;
    gridData: v_InvoiceLineItemBus[];
    id: any;
    customerLocations2: GItem[] = null;

    _customerId: any;
    _locationId: any;
    _customerId2: any;
    _locationId2: any;
    get customerId(): any {
        return this._customerId;
    }
    get locationId(): any {
        return this._locationId;
    }
    set customerId(value: any) {
        this._customerId = value;
    }
    set locationId(value: any) {
        this._locationId = value;
    }
    get customerId2(): any {
        return this._customerId2;
    }
    get locationId2(): any {
        return this._locationId2;
    }
    set customerId2(value: any) {
        this._customerId2 = value;
    }
    set locationId2(value: any) {
        this._locationId2 = value;
    }
    labor: number = 0;
    material: number = 0;
    other: number = 0;
    total: number = 0;
    tax: number = 0;
    isTaxable: boolean = false;
    isTaxOnly: boolean = false;

    close(data: any = null) {
        //        super.close(data);
        this.gridData = null;
        this.editing = false;
        this.closed.emit(data);
    }

    cancel() {
        this.gridData = null;
//        this.clear();
        this.editing = false;
        this.closed.emit(false);
    }
    invoice: InvoiceBus;

    getData() {
        this.dataLoading = true;
        this.subs_data = this.svc_data.getLineItemsViewForCMOrCORR(this.id, this.code).subscribe((info: InvoiceMessageInfo) => {
            if (!info.saveError) {
                this.invoice = new InvoiceBus(info.invoice);
                this.locationIdToSet = this.invoice.locationId;
                this.customerId = this.invoice.customerId;
                this.customerChanged(this.customerId);
                let arr = [];
                for (let i = 0; i < info.primaryReturn.length; i++) {
                    let busObj: v_InvoiceLineItemBus = new v_InvoiceLineItemBus(info.primaryReturn[i]);
                    busObj.corr1Qty = 0;
                    busObj.corr2Qty = 0;
                    busObj.splitQuantity = 0;
                    busObj.amountCorr1 = 0;
                    busObj.amountCorr2 = 0;
                    busObj.amountCredit = 0;
                    busObj.corr1IsBillable = true;
                    busObj.corr2IsBillable = true;
                    arr.push(busObj);
                }

                this.gridData = arr; // info.primaryReturn as OrderBillBus[];
                this.dataLoading = false;
                this.editing = true;
                if (this.code == 'S') {
                    this.setAllCORR1();
                }
            }
        });

    }
    setAllCORR1() {
        for (let i = 0; i < this.gridData.length; i++) {
            this.gridData[i].corr1Qty = this.gridData[i].quantity;
            this.gridData[i].amountCorr1 = this.gridData[i].corr1Qty * this.gridData[i].price;
            this.gridData[i].totalCostCorr1 = this.gridData[i].corr1Qty * this.gridData[i].cost;
        }
    }
    goTo() {
        this.closed.emit(this.newInvoiceId);
    }
    newInvoiceNumber: string;
    newInvoiceId: any;
    get hasNewInvoiceId(): boolean {
        return CommonFunctions.hasGuidValue(this.newInvoiceId);
    }
    getSelected(code: string = "CR"): InvoiceLinesBus[] {
        let selArr: v_InvoiceLineItemBus[] = [];
        let arr: InvoiceLinesBus[] = [];
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            if (code === "CR") {
                selArr = this.gridData.filter(s => s.splitQuantity !== 0);
            }
            else if (code === "CORR") {
                selArr = this.gridData.filter(s => s.corr1Qty !== 0);
            }
            else if (code === "CORR2") {
                selArr = this.gridData.filter(s => s.corr2Qty !== 0);
            }
        }

        if (CommonFunctions.hasArrayElementValue(selArr)) {
            for (let i = 0; i < selArr.length; i++) {
                let busObj: InvoiceLinesBus = new InvoiceLinesBus(selArr[i]);
                arr.push(busObj);
            }
        }
        return arr;
    }
    saveAll() {
        this.editing = false;
        let param: InvoiceLinesSaveParam = new InvoiceLinesSaveParam();
        param.invoiceId = this.id;
        param.customerId = this.customerId;
        param.locationId = this.locationId;
        param.customerId2 = this.customerId2;
        param.locationId2 = this.locationId2;
        param.code = this.code;
        let cParam: CommonParam = new CommonParam();
        if (this.isCreditMemo) {
            //Use Specific Amounts not LineItems
            param.isTaxable = this.isTaxable;
            if (this.total !== 0) {
                param.labor = this.labor * -1;
                param.material = this.material * -1;
                param.other = this.other * -1;
            }
            else if (this.isTaxOnly) {
                param.isTaxOnly = this.isTaxOnly;
                param.tax = this.tax * -1;
            }
            else {
                param.lineItems = this.getSelected("CR");
            }
        }
        else {
            param.lineItemsCORR = this.getSelected("CORR");
            param.lineItemsCORR2 = this.getSelected("CORR2");
        }

        //return;
        this.compLoader.cpLoaderOn(true);
        this.svc_data.saveCreditMemoOrCORR(param).subscribe((info: InvoiceMessageInfo) => {
            if (!info.saveError) {
                this.saveSuccess();
            }
            else {
                this.saveError(info.message);
            }
            this.compLoader.cpLoaderOff();
            this.closed.emit(!info.saveError);
        });
    }
    get hasGridData(): boolean {
        return CommonFunctions.hasValue(this.gridData);
    }
    get gridDataCount(): number {
        return CommonFunctions.hasArrayElementValue(this.gridData) ? this.gridData.length : 0;
    }
    get customerLocationSelectionValid() : boolean {
        let valid = true;
        if (this.isCreditMemo) {
            if (this.hasCustomer && !this.hasLocation) {
                valid = false;
            }
        }
        return valid;
    }
    get canSave(): boolean {
        let okToSave: boolean = this.gridDataCount > 0; // && (this.code !== "W" || (this.code === "W"));
        return okToSave;
    }
    qtyCORR: number = 1;
    isCreditMemo: boolean = false;
    code: string = null;
    setup({id,code }) {
        this.newInvoiceId = null;
        this.newInvoiceNumber = null;
        this.customerId = null;
        this.locationId = null;
        this.customerId2 = null;
        this.locationId2 = null;
        this.gridData = [];
        this.id = id;
        this.code = code; //CR - Credit Memo, S - CM & 1 CORR, M - CM & 2 CORR
        if (this.code === "M") {
            this.qtyCORR = 2;
        }
        this.isCreditMemo = this.code === "CR" ? true : false;
        this.getData();
    }
    onChanged(e: BaseMessageInfo) {
        console.log("onChanged: ", e);
    }

    customerCBOChanged(item: any) {
        if (CommonFunctions.hasValue(item)) {
            this.customerChanged(item.value);
        }
        else {
            this.customerChanged(null);
        }
    }
    locationCBOChanged(item: GItem) {
        if (CommonFunctions.hasValue(item)) {
            this.locationChanged(item.value);
        }
        else {
            this.locationChanged(null);
        }
    }
    locationCBOChanged2(item: GItem) {

    }
    customerCBOChanged2(item: any) {
        if (CommonFunctions.hasValue(item)) {
            this.customerChanged2(item.value);
        }
        else {
            this.customerChanged2(null);
        }
    }
    customerChanged2(id: any, holdLocationChange: boolean = false) {
        this.location = null;
        let custId: any = id;
        if (CommonFunctions.hasValue(this.referenceData) && CommonFunctions.hasArrayValue(this.referenceData.locations) && CommonFunctions.hasValue(id)) {
            this.customerLocations2 = this.referenceData.locations.filter(e => e.category === id);
        }
        else {
            this.customerLocations2 = [];
        }
    }

    locationIdToSet: any = null;
    customerChanged(id: any, holdLocationChange: boolean = false) {
        this.location = null;
        let custId: any = id;
        if (CommonFunctions.hasValue(this.referenceData) && CommonFunctions.hasArrayValue(this.referenceData.locations) && CommonFunctions.hasValue(id)) {
            this.customer = this.referenceData.getCustomerDesc(id); // .customers.find(s => s.value === id).description;
            this.customerLocations = this.referenceData.locations.filter(e => e.category === id);
            if (CommonFunctions.hasGuidValue(this.locationIdToSet)) {
                this.locationId = this.locationIdToSet;
                this.locationIdToSet = null;
            }
        }
        else {
            this.customer = null;
            //  this.editForm.value.customerId = null;
            this.customerLocations = [];
            this.customerGeoLocations = [];
        }
//        this.locationChanged(null);
    }
    crValueChanged(e: any, code: string) {
        this.calculateCRTotal();
    }
    isTaxableChanged(e: any) {

    }
    taxOnlyChanged(e: any) {

    }
    calculateCRTotal() {
        this.total = this.labor + this.material + this.other;
    }
}
